

import apiWorker from '../apiWorker'

const failed_name_logs = {
    findByContact : (contact_id) => apiWorker('get', `/v1/analytics/failed_name_logs/${contact_id}`),
}

export default failed_name_logs;